import { render, staticRenderFns } from "./PostBillingBatch.vue?vue&type=template&id=5776b49d&scoped=true"
import script from "./PostBillingBatch.vue?vue&type=script&lang=js"
export * from "./PostBillingBatch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5776b49d",
  null
  
)

export default component.exports